import CameraCapture from './CameraCapture.jsx';

/**
 * Wraps CameraCapture with documentation-specific framing instructions.
 * Reuses the same UI but with a doc-friendly prompt and a different aspect ratio guide.
 */
export default function DocumentScanner({ onCapture, onCancel }) {
  return (
    <CameraCapture
      onCapture={onCapture}
      onCancel={onCancel}
      prompt="Hold steady — fill the frame with the tech sheet or wiring diagram"
    />
  );
}
